import React from "react";
import PlusIcon from "../../../../../icons/plus.icon";
import MyDropdown from "../../../../../Common/my-dropdown/my-dropdown-new.component";
import styles from "./index.module.scss";

export interface IDistributor {
  id: string;
  name: string;
  image: string;
}

interface AddDistributorDropdownProps {
  onDistributorAdd: (distributor: IDistributor) => void;
  distributors: IDistributor[];
  availableDistributors: IDistributor[];
}

export const AddDistributorDropdown = ({ onDistributorAdd, distributors, availableDistributors }: AddDistributorDropdownProps) => {
  const handleDistributorSelect = (distributor: IDistributor) => {
    onDistributorAdd(distributor);
  };

  return (
    <MyDropdown
      menuClassName={styles.menu}
    >
      <MyDropdown.Toggle className={styles.button} hideArrow>
        <span className={styles.iconWrapper}>
          <PlusIcon />
        </span>
        <span className={styles.textWrapper}>
          <span className={styles.text}>
            Add
          </span>
        </span>
      </MyDropdown.Toggle>

      <MyDropdown.Menu popperConfig={{ strategy: "fixed" }} renderOnMount>
        <div className={styles.menuHeader}>
          Distributors
        </div>
        {availableDistributors.filter((distributor) => !distributors.some((d) => d.id === distributor.id)).map((distributor) => (
          <MyDropdown.Item
            key={distributor.id}
            onClick={() => handleDistributorSelect(distributor)}
            className={styles.item}
          >
            <img 
              src={distributor.image} 
              alt={distributor.name} 
              className={styles.distributorIcon}
            />
            <span className={styles.distributorName}>{distributor.name}</span>
          </MyDropdown.Item>
        ))}
      </MyDropdown.Menu>
    </MyDropdown>
  );
};